import { getRootUrl } from '@bingads-webui-react/copilot-utils';
import { getBotMtApiUrl } from './utils/xandr-bot-mt';
import type { ChatHistoryRequestContext, RequestHeaders } from './types';

export interface IGetConversationsProps extends ChatHistoryRequestContext {
  top?: number;
  skip?: number;
}

function getConversationsUrl({
  cid,
  uid,
  top,
  skip,
  productName,
}: IGetConversationsProps) {
  if (productName === 'xandr_curate' || productName === 'xandr_monetization') {
    // need to bypass /tokenexchange for xandr products, default to token exchange for all others
    return `${getBotMtApiUrl()}/chathistory?userId=${encodeURIComponent(uid)}&customerId=${encodeURIComponent(cid)}&top=${encodeURIComponent(top ?? '')}&skip=${encodeURIComponent(skip ?? '')}`;
  }
  return `${getRootUrl()}/tokenexchange/chathistory?uid=${encodeURIComponent(uid)}&cid=${encodeURIComponent(cid)}&top=${encodeURIComponent(top ?? '')}&skip=${encodeURIComponent(skip ?? '')}`;
}

export interface ConversationResponse {
  conversations: unknown[];
}

export function getConversations({
  cid,
  uid,
  top = 30,
  skip = 0,
  productName,
  authToken,
}: IGetConversationsProps) {
  const url = getConversationsUrl({
    cid, uid, top, skip, productName,
  });
  const isXandrProduct = productName === 'xandr_curate' || productName === 'xandr_monetization';
  const headers: RequestHeaders = {
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
  };
  if (isXandrProduct && authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  return window.fetch(url, {
    method: 'GET',
    headers,
    credentials: isXandrProduct ? 'omit' : 'include',
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text());
      }
      const result = await response.json();
      // @aiContributed-MAPFuse-2026-02-05
      const conversations = result?.Conversations ?? result?.conversations ?? [];
      return {
        data: { conversations },
        hasError: false,
      };
    })
    .catch(error => ({
      hasError: true,
      message: 'Failed to retrieve conversations',
      error: error?.message,
    }));
}
